/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Apple = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.1082 2C16.2317 3.18385 15.7636 4.34236 15.0738 5.20517C14.3591 6.04378 13.2266 6.7087 12.093 6.61038C11.9452 5.47615 12.5122 4.26914 13.1528 3.52969C13.8662 2.6662 15.0984 2.05021 16.1082 2ZM13.4475 7.42102C14.1838 7.13093 15.0939 6.77236 16.0952 6.83201C16.734 6.88142 18.5766 7.07809 19.7559 8.82228C19.75 8.82675 19.737 8.83529 19.7177 8.84792C19.4149 9.04607 17.5708 10.2528 17.5941 12.6326C17.617 15.468 19.93 16.5311 20.2379 16.6726C20.2583 16.682 20.2699 16.6873 20.2715 16.6888C20.2702 16.6927 20.2679 16.7 20.2646 16.7106C20.2045 16.9036 19.8048 18.1879 18.8962 19.5155C18.0609 20.7451 17.2008 21.9496 15.825 21.9742C15.1774 21.9862 14.7405 21.799 14.2858 21.6042C13.809 21.3999 13.3127 21.1872 12.5334 21.1872C11.716 21.1872 11.1958 21.4067 10.6955 21.6177C10.2634 21.8 9.84626 21.976 9.26539 21.9988C7.9389 22.0473 6.93219 20.6948 6.09687 19.4663C4.37676 16.9833 3.07471 12.461 4.84356 9.41234C5.70355 7.88836 7.27603 6.93016 8.97073 6.90527C9.7106 6.89172 10.4188 7.17159 11.0367 7.41579C11.5062 7.60134 11.9236 7.7663 12.2632 7.7663C12.5712 7.7663 12.9733 7.60786 13.4475 7.42102Z"
                        fill={color}
                    />
                </svg>
        );
    };
